import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { ApiService } from '../lib/api.service';
import { ProgressService } from '../lib/progress.service';

export const bookingBasicsGuard: CanActivateFn = (route, state) => {
  const progressService = inject(ProgressService);

  const bookingBasicsDone =
    !!progressService.selectedFestival() &&
    !!progressService.selectedDate() &&
    !!progressService.selectedDayslot() &&
    !!progressService.selectedLodge();

  if (!bookingBasicsDone) {
    const router = inject(Router);
    router.navigateByUrl('/');
  }

  return bookingBasicsDone;
};
